import { VendorContactTypeService, VendorService } from '@controlling/proxy/controlling/controllers';
import { VendorContactType } from '@controlling/vendor-contact-type/vendor-contact-type';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const VENDORCONTACT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VendorContact.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('telephoneNumber', 'Entity.VendorContact.TelephoneNumber')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('cellphoneNumber', 'Entity.VendorContact.CellphoneNumber')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('faxNumber', 'Entity.VendorContact.FaxNumber')
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('email', 'Entity.VendorContact.Email')
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('canReceiveEmail', 'Entity.VendorContact.CanReceiveEmail')
    .build(),
  FieldBuilder
    .foreignKey('vendorContactTypeId', 'Entity.VendorContactType', VendorContactTypeService)
    .displayFromNested('vendorContactType.name')
    .sortBy('vendorContactType.name')
    .build(),
  FieldBuilder
    .checkbox('mustNotifyServiceOrderApproval', 'Entity.VendorContact.MustNotifyServiceOrderApproval')
    .build(),
  FieldBuilder
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .displayFromNested('vendor.fantasyName')
    .sortBy('vendor.fantasyName')
    .hideInChildForms()
    .build(),
];

export const VENDORCONTACT_CONFIG = {
  entityName: 'VendorContact',
  localizationKey: 'Controlling::Entity.VendorContact',
  fields: VENDORCONTACT_FIELDS,
  permission: 'ControllingContract.VendorContacts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
